var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcContractServiceBody2Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 169,
    viewBox: "0 0 191 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_823)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.575,
    y: 33.9072,
    width: 8.57983,
    height: 45.7591,
    transform: "rotate(8.28361 149.575 33.9072)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.867,
    cy: 28.5456,
    r: 25.6,
    transform: "rotate(-10.093 155.867 28.5456)",
    fill: "#BDE9FF",
    stroke: "#D9D9D9",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.052 75.7465L120.436 77.5425C116.746 80.0764 113.613 83.3389 111.231 87.1292L103.147 99.9911L117.211 118.298L143.221 115.668C146.801 115.306 149.879 112.972 151.193 109.622L152.578 106.089C152.979 105.068 153.246 103.999 153.374 102.909L154.136 96.4236L155.965 94.8025C158.05 92.9549 159.023 90.156 158.535 87.4136L157.842 83.5225L160.536 83.0431C162.712 82.6557 164.343 80.8318 164.485 78.6257L164.774 74.1318C164.832 73.2274 164.128 72.4553 163.222 72.4296L136.841 71.682C131.93 71.5429 127.102 72.9661 123.052 75.7465Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.643 93.7939L126.52 125.239L119.919 130.461L95.0425 99.0158L101.643 93.7939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4795 97.1846L121.344 132.407L4.87837 224.545L-22.9864 189.323L93.4795 97.1846Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.664,
    cy: 136.663,
    r: 2.71164,
    transform: "rotate(51.0376 106.664 136.663)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5942,
    cy: 143.264,
    r: 2.71164,
    transform: "rotate(51.0376 98.5942 143.264)",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189.6,
    height: 168,
    fill: "white",
    transform: "translate(0.700195 0.200195)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContractServiceBody2Mobile);
export default __webpack_public_path__ + "static/media/IcContractServiceBody2Mobile.866d6fcdd3de4c4afb4862b7bc8a4734.svg";
export { ForwardRef as ReactComponent };